import * as styles from "../../../styles/DefaultSetting";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import userSlice from "../../../reducer/user";
import { useAppDispatch } from "../../../store";

import dayjs from "dayjs";
import "dayjs/locale/ko";

const FeedAdd = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(userSlice.actions.Routerpath(`/FeedAdd`));
  }, []);
  const navigate = useNavigate();
  let [date, setDate] = useState({
    date: "",
    time: "",
  });
  let inputtime: any;
  const feedNameRef = useRef<any>(null);
  const feedPurchaseBagsRef = useRef<any>(null);
  const feedPurchaseBagUnitRef = useRef<any>(null);

  const feedPurchaseDateRef = useRef<any>(null);
  const feedLowLimitRef = useRef<any>(null);

  let [addFeed, setAddFeed] = useState<any>({
    feedName: "",
    feedPurchaseBags: "", //사료구입량
    feedPurchaseBagUnit: "", // 포대 단위
    feedPurchaseDate: inputtime,
    feedLowLimit: "",
  });
  //입력받은 날짜 데이터
  const InputHandler = (e: any) => {
    const { name, value } = e.target;
    setAddFeed({
      ...addFeed,
      [name]: value,
    });
  };

useEffect(() => {
	let inputtime = date.time && date.date ? date.date + " " + date.time : dayjs().format("YYYY-MM-DD");
	setAddFeed({
		...addFeed,
		feedPurchaseDate: inputtime,
	});
}, [date]);

  const FeedAdd = () => {
    if (addFeed.feedName === "") {
      confirmAlert({
        title: "사료명을 입력해주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
      feedNameRef.current.focus();
      return;
    } else if (addFeed.feedPurchaseBags === "") {
      confirmAlert({
        title: "사료구입량을 입력해주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
      feedPurchaseBagsRef.current.focus();
      return;
    } else if (addFeed.feedPurchaseBagUnit === "") {
      confirmAlert({
        title: "사료포대 단위를 입력해주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
      feedPurchaseBagUnitRef.current.focus();
      return;
    } else if (
      addFeed.feedPurchaseDate === "" ||
      addFeed.feedPurchaseDate === null
    ) {
      confirmAlert({
        title: "구입날짜 입력해주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
      feedPurchaseDateRef.current.focus();
      return;
    } else if (addFeed.feedLowLimit === "") {
      confirmAlert({
        title: "알람임계치를 입력해주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
      feedLowLimitRef.current.focus();
      return;
    }

    if (addFeed.feedName.includes(" ")) {
      return confirmAlert({
        title: "사료명에 공백이 있습니다. 공백을 제거해주세요",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }
    axios
      .post("ifactory/api/feed", {
        feedName: addFeed.feedName,
        feedPurchaseBags: Number(addFeed.feedPurchaseBags),
        feedPurchaseBagUnit: Number(addFeed.feedPurchaseBagUnit),
        feedPurchaseDate: addFeed.feedPurchaseDate,
				feedLowLimit: Number(addFeed.feedLowLimit),
				farmId : Number(localStorage.getItem("targetfarm"))
      })
      .then((res) => {
        confirmAlert({
          title: "사료 등록이 완료되었습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        navigate("/Feedmanagement");
      })
      .catch((error) => {
        confirmAlert({
          title: error.response.data.message,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      });
  };
  return (
    <styles.Container>
      <styles.PageTop>
        <p className="move-btn">
          <img src="./img/ArrowLeft.svg" alt="좌향화살표" onClick={() => { navigate("/Feedmanagement") }}/>
        </p>
        <p className="pagetit">사료 관리 설정</p>
      </styles.PageTop>
      <styles.PageTitle>
        <div className="title">
          <img src="./img/MiniFeed.svg" alt="사료이미지" />
          <p>사료 관리</p>
        </div>
      </styles.PageTitle>

      <styles.FeedAddBox>
        <div className="itemlist">
          <div className="list-title">
            <p>사료명</p>
          </div>
          <div className="list-input">
            <input
              type="text"
              ref={feedNameRef}
              value={addFeed.feedName || ""}
              name="feedName"
              onChange={InputHandler}
            />
          </div>
          <button onClick={() => { FeedAdd() }} > 추가</button>
        </div>

        <div className="itemlist">
          <div className="list-title">
            <p>사료구입날짜</p>
          </div>
          <div className="list-input">
            <input
              style={{ height: 40, width: "100%" }}
              type="date"
              ref={feedPurchaseDateRef}
              name="feedPurchaseDate"
              value={addFeed.feedPurchaseDate || ""}
              onChange={InputHandler}
            />
          </div>
        </div>

        <div className="itemlist">
          <div className="list-title">
            <p>사료구입량(포대)</p>
          </div>
          <div className="list-input">
            <input
              style={{ height: 40, width: "100%" }}
              type="number"
              ref={feedPurchaseBagsRef}
              value={addFeed.feedPurchaseBags || ""}
              name="feedPurchaseBags"
              onChange={InputHandler}
            />
          </div>
        </div>

        <div className="itemlist">
          <div className="list-title">
            <p>포대 단위 (kg)</p>
          </div>
          <div className="list-input">
            <input
              style={{ height: 40, width: "100%" }}
              type="number"
              ref={feedPurchaseBagUnitRef}
              value={addFeed.feedPurchaseBagUnit || ""}
              name="feedPurchaseBagUnit"
              onChange={InputHandler}
            />
          </div>
        </div>

        <div className="itemlist">
          <div className="list-title">
            <p>알람임계치(g)</p>
          </div>
          <div className="list-input">
            <input
              style={{ height: 40, width: "100%" }}
              type="number"
              ref={feedLowLimitRef}
              value={addFeed.feedLowLimit || ""}
              name="feedLowLimit"
              onChange={InputHandler}
            />
          </div>
        </div>
      </styles.FeedAddBox>
    </styles.Container>
  );
};

export default FeedAdd;
